import { render } from "./UnsubscribeModal.vue?vue&type=template&id=fd3af900&scoped=true"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js"

import "./UnsubscribeModal.vue?vue&type=style&index=0&id=fd3af900&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3af900"]])

export default __exports__